import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './LoginForm';

const Showcase: React.FC = () => {
  return (
    <div className='showcase'>
      <div className='container'>
        <div className='showcase-content'>
          <div className='showcase-left'>
            <h1>EZZE Bank</h1>
            <p className='showcase-desc'>
              Banking made easier. Need a place to stash your cash? We've got
              you covered. Managing finances is what we do. And you can bet we
              do it as securely and as conveniently for you as possible.
            </p>
            <Link to={'/signup'} className='register-btn'>
              Register Account
            </Link>
          </div>
          <div className='showcase-right'>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Showcase;
